import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CheckoutSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate('/dashboard'), 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-indigo-50 flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-3">You're in!</h1>
        <p className="text-gray-600 mb-8">
          Your subscription is now active. Welcome to Journal Coffee Premium — enjoy unlimited access to all research.
        </p>
        <button
          onClick={() => navigate('/dashboard')}
          className="stripe-gradient text-white px-8 py-3 rounded-xl font-semibold hover:opacity-90 transition-opacity"
        >
          Go to your library
        </button>
        <p className="text-xs text-gray-400 mt-4">Redirecting automatically in 5 seconds…</p>
      </div>
    </div>
  );
};

export default CheckoutSuccess;
